import { throttle } from '../../application/utils/timings'

export class ProductSummary {
  constructor(controls) {
    this.controls = controls.filter(
      (control) => control.type === 'size' || control.type === 'color'
    )
    this.renderNodes = document.querySelectorAll(
      '[data-product-summary-render]'
    )
    this.createHooks()
    this.render()
  }

  createHooks() {
    this.controls.forEach((control) => {
      control.watch = throttle(this.render.bind(this), 100)
    })
  }

  template(control) {
    if (control.type === 'color') {
      return /*html*/ `
      <div class="product-control product-control--row" data-type="color">
        <div class="product-control__heading">
          <span>Color:</span> <span>${control.activeItem.label}</span>
        </div>
        <div class="product-control-item is-active" data-type="color">
          ${control.activeItem.el.innerHTML}
        </div>
      </div>
      `
    }
    if (control.type === 'size') {
      return /*html*/ `
      <div class="product-control product-control--row" data-type="size">
        <div class="product-control__heading">
          <span>Size:</span> <span>${control.activeItem.label}</span>
        </div>
        <div class="product-control-item" data-type="size">
          ${control.activeItem.el.innerHTML}
        </div>
      </div>
      `
    }
  }

  render() {
    const template = []
    this.controls.forEach((control) => {
      template.push(this.template(control))
    })
    this.renderNodes.forEach((node) => (node.innerHTML = template.join('')))
  }
}
